export const APP_ENV_NAME = process.env.REACT_APP_ENV_NAME || "DEVELOP";
export const RELEASE_VERSION =
  process.env.REACT_APP_RELEASE_VERSION || APP_ENV_NAME;

export const BACKEND_BASE_URL = process.env.REACT_APP_API_ENDPOINT;
export const BACKEND_USER = process.env.REACT_APP_API_USER;
export const BACKEND_PASSWORD = process.env.REACT_APP_API_PASSWORD;

export const LEVEL_DEFAULT = "Default";
export const LEVEL_TYPE_EASY = "Leicht";
export const LEVEL_TYPE_MEDIUM = "Mittel";
export const LEVEL_TYPE_ADVANCED = "Schwer";

export const LEVEL_FALLBACK_TYPE = LEVEL_TYPE_MEDIUM;

export const levelIdLabelMap = {
  99: LEVEL_DEFAULT,
  1: LEVEL_TYPE_EASY,
  2: LEVEL_TYPE_MEDIUM,
  3: LEVEL_TYPE_ADVANCED,
};

export const levelIdColorMap = {
  99: "#bad1e2",
  1: "#008000",
  2: "#ffa500",
  3: "#ff0000",
};
